import { resolveActiveWorkspaceContext } from "@/lib/active-workspace";
import { getUserStoreState } from "@/store/user/user-store";

const CONNECTOR_API_PATH_PREFIX = "/api/ai-transform/v1/";

function getRequestPath(url: string): string {
  try {
    const base =
      typeof window === "undefined" ? "http://localhost" : window.location.origin;
    return new URL(url, base).pathname;
  } catch {
    return url.split("?", 1)[0] ?? "";
  }
}

export function isConnectorApiRequest(url: string): boolean {
  return getRequestPath(url).startsWith(CONNECTOR_API_PATH_PREFIX);
}

export function hasCurrentConnectorEntitlementScope(): boolean {
  if (typeof window === "undefined") return false;

  const activeWorkspace = resolveActiveWorkspaceContext();
  if (
    !activeWorkspace.workspacesLoaded ||
    !activeWorkspace.organizationId ||
    !activeWorkspace.workspaceId
  ) {
    return false;
  }

  const expectedKey = `${activeWorkspace.organizationId}:${activeWorkspace.workspaceId}`;
  const authState = getUserStoreState();
  return Boolean(
    !authState.isEntitlementsLoading &&
      authState.activeEntitlementWorkspaceKey === expectedKey &&
      authState.entitlementsByWorkspace[expectedKey],
  );
}

export function assertCurrentConnectorEntitlementScope(): void {
  if (!hasCurrentConnectorEntitlementScope()) {
    throw new Error("Connector access context is not ready");
  }
}
